document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', function (e) {
        const hashIndex = this.href.indexOf('#');
        if (hashIndex !== -1) {
            const hash = this.href.substring(hashIndex);
            const targetEl = document.querySelector(hash);
            if (!targetEl) {
                // Reload the page with the hash
                window.location.href = this.href;
            } else {
                e.preventDefault(); // Smooth scroll if the element is found
                targetEl.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
});
